import * as Yup from "yup";
import { TStep } from "../types";
import {
  states,
  yesNo,
  AboriginalOrTorresStrait,
  methodOfContact,
  Concerns,
  Outcomes,
} from "./questionOptions";

export const legalAdviceSteps: {
  [key: string]: TStep;
} = {
  "legal-step-two": {
    title: "Select the location of your concern",
    type: "form",
    note: "Environmental law is different across the country and will affect the advice we provide.",
    components: [
      {
        type: "radio",
        name: "location",
        options: states,
        validation: Yup.string().required("Please select one Location"),
      },
    ],
    next: (values) => {
      if (values.location === "pacific-region") {
        return "/apply/no";
      } else {
        return "legal-step-three";
      }
    },
    previous: "legal-step-one",
    submit: false,
    stepNumber: "7",
    stepPath: "/apply/location",
    stepText: "Step 1 of 5",
  },
  "legal-step-three": {
    title: "Tell us about you",
    type: "form",
    note: `If you identify as an Aboriginal, Torres Strait Islander or a First Nations person or English is not your first language, please let us know. This information is optional, but it helps us to arrange for a team member to contact you directly to get the information for your application and arrange an interpreter if you need one.`,
    components: [
      {
        label: "Do you need an interpreter?",
        type: "radio",
        name: "languageOtherThanEng",
        options: yesNo,
      },
      {
        label: "Please specify your preferred language",
        type: "text",
        name: "language",
        condition: { languageOtherThanEng: "yes" },
        validation: Yup.string().when("languageOtherThanEng", {
          is: "yes",
          then: Yup.string().required(),
        }),
      },
      {
        label: "Do you identify as a First Nations person?",
        type: "radio",
        name: "aboriginalOrTorresStrait",
        options: AboriginalOrTorresStrait,
      },
    ],
    next: (values) => {
      if (
        (values.aboriginalOrTorresStrait !== "" && values.aboriginalOrTorresStrait !== "no") ||
        (values.languageOtherThanEng !== "no" && values.languageOtherThanEng !== "")
      ) {
        return "legal-step-four";
      } else return "legal-step-five";
    },
    previous: "legal-step-two",
    submit: false,
    stepNumber: "8",
    stepPath: "/apply/about-you",
    stepText: "Step 2 of 5",
  },
  "legal-step-four": {
    title: "We'll get back to you",
    type: "form",
    note: `Please enter your details below and a team member will contact you within two business days to collect the information we need for your application. We may arrange an interpreter if you let us know you prefer to speak another language.`,
    components: [
      {
        label: "Given name*",
        type: "text",
        name: "contactFirstName",
        validation: Yup.string().required("Please enter valid first name"),
      },
      {
        label: "Family name*",
        type: "text",
        name: "contactLastName",
        validation: Yup.string().required("Please enter valid last name"),
      },
      {
        label: "Email",
        type: "email",
        name: "contactEmail",
        validation: Yup.string().email("Please enter valid email"),
      },
      {
        label: "Contact number*",
        type: "tel",
        name: "contactNumber",
        validation: Yup.string()
          .required("Please enter valid phone number, including area code")
          .matches(/^\(?([0-9]{3})\)?([0-9]{3})([0-9]{4})$/, "Please enter valid phone number, including area code"),
      },
      {
        label: "Preferred method of contact",
        type: "select",
        options: methodOfContact,
        name: "preferredContactMethod",
      },
    ],
    previous: "legal-step-three",
    submit: true,
    stepNumber: "7.1",
    next: "/apply/priority-thanks",
  },
  "legal-step-five": {
    title: "How would you describe your main concern?",
    type: "form",
    note: "Select what most closely matches your concern or select ‘other’ if you don’t see anything that fits.",
    components: [
      {
        type: "radio",
        name: "concern",
        options: Concerns,
        validation: Yup.string().required("Please select at least 1 option"),
      },
    ],
    next: (values) => {
      if (values.concern === "environmental-protest") {
        return "protesting-step-one";
      } else {
        return "legal-step-six";
      }
    },
    previous: "legal-step-three",
    submit: false,
    stepNumber: "9",
    stepPath: "/apply/main-concern",
    stepText: "Step 3 of 5",
  },
  "legal-step-six": {
    title: "What outcome would you like to achieve?",
    type: "form",
    note: "Select as many as are relevant.",
    components: [
      {
        type: "checkbox",
        name: "outcomes",
        options: Outcomes,
        validation: Yup.array().min(1, "Please select at least 1"),
      },
    ],
    next: (values) => {
      if (
//        values.concern.includes("local-developments-and-private-disputes") ||
//        values.concern.includes("pest-and-weed-control")
          values.outcomes.includes("protect-property-and-amenity") &&
          values.outcomes.length == 1
      ) {
        return "/apply/no";
      } else {
        return "eligible-step-one";
      }
    },
    previous: "legal-step-five",
    submit: false,
    stepNumber: "10",
    stepPath: "/apply/outcome",
    stepText: "Step 4 of 5",
  },
};
